"use strict";
var State = (function () {
    function State(isoCode2, name) {
        this.isoCode2 = isoCode2;
        this.name = name;
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=D:/a/1/s/base/src/models/state.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/state.model.js